export const FLAG_ITINERARY_SUPPLIER_FOOD_ACTIVITY =
  'FLAG_ITINERARY_SUPPLIER_FOOD_ACTIVITY';
export const GET_ITINERARY_SUPPLIER_FOOD = 'GET_ITINERARY_SUPPLIER_FOOD';
export const CLEAR_ITINERARY_SUPPLIER_FOOD = 'CLEAR_ITINERARY_SUPPLIER_FOOD';
export const FLAG_ITINERARY_SUPPLIER_FOODS = 'FLAG_ITINERARY_SUPPLIER_FOODS';
export const GET_ITINERARY_SUPPLIER_FOODS = 'GET_ITINERARY_SUPPLIER_FOODS';
export const CLEAR_ITINERARY_SUPPLIER_FOODS = 'CLEAR_ITINERARY_SUPPLIER_FOODS';
export const GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE =
  'GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE';
export const CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE =
  'CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE';
export const FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE =
  'FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE';
export const FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT =
  'FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT';
export const GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT =
  'GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT';
export const CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT =
  'CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT';
export const FLAG_GETTING_ITINERARY_SUPPLIER_FOOD_REPORT =
  'FLAG_GETTING_ITINERARY_SUPPLIER_FOOD_REPORT';
export const GET_ITINERARY_SUPPLIER_FOOD_REPORT =
  'GET_ITINERARY_SUPPLIER_FOOD_REPORT';
export const CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT =
  'CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT';
export const GET_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL =
  'GET_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL';
export const CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL =
  'CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL';
